import { VNode } from "preact"
import { Route, RouteProps, useLocation } from "wouter-preact"

import { Container } from "@/app/container.tsx"
import { is_page_hidden } from "@/app/page_access"
import { UserState } from "@/auth/user"
import { useOrgSettings } from "@/org_settings/state"

/** Shown instead of a page the org keeps from this user, so a saved link says why it stopped. */
function PageHiddenNotice() {
  return (
    <div class="mx-4 mt-8 max-w-xl rounded-lg border border-gray-200 bg-white p-6">
      <h1 class="text-lg font-semibold text-gray-900">This page is not available to your team</h1>
      <p class="mt-2 text-sm text-gray-600">
        Your organization keeps the accounting pages from the Sales team. An org admin can change that under
        Settings, Organization.
      </p>
      <a href="/deductions" class="mt-4 inline-block text-sm text-blue-600 underline">
        Go to deductions
      </a>
    </div>
  )
}

/** The app shell, with a page this user's org keeps from them replaced by a notice. */
export function GatedContainer({ children }: { children: Array<VNode<RouteProps>> }) {
  const [location] = useLocation()
  const user = UserState.use()
  const settings = useOrgSettings()
  if (is_page_hidden(location, user, settings)) {
    return <Container>{[<Route component={PageHiddenNotice} />]}</Container>
  }
  return <Container>{children}</Container>
}
